export default __webpack_public_path__ + "static/media/pf-1.6a11654e.webp";